import local from './local';
import development from './development';
import test from './test';
import preproduction from './preproduction';
import production from './production';

const envs = {
  localhost: local,
  'dev.': development,
  'test.': test,
  'pre.': preproduction,
};

const host = window.location.host;
let env = production;

Object.keys(envs).forEach(item => {
  if (host.match(item)) {
    env = envs[item];
  }
});

export default env;
